import { create } from 'zustand';

type useLoggedInUserTypeStore = {
  userType: 'invisalign' | 'dso';
  setUserType: (userType: 'invisalign' | 'dso') => void;
};

export const useLoggedInUserTypeStore = create<useLoggedInUserTypeStore>(
  set => ({
    userType: 'invisalign',
    setUserType: userType => {
      set({ userType });
    },
  })
);
